var map = {
	"./AppStore.png": 7793,
	"./anzhuo.png": 4230,
	"./google.png": 2580,
	"./honor.png": 661,
	"./huawei.png": 7806,
	"./mi.png": 9579,
	"./oppo.png": 6991,
	"./sanxing.png": 1895,
	"./vivo.png": 7003,
	"./yingyongbao.png": 457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6381;